export const homeFeaturedEvents = [
  {
    id: 1,
    title: "Resume Ready",
    description:
      "Level up your resume before EWI. Join us for a hands-on workshop where we break down what recruiters actually look for, walk through real resume examples across engineering majors, and give you live peer feedback on your own draft. Whether you're starting from scratch or polishing what you have, leave with a resume you're proud of.",
    location: "Cohen Room, Engineering VI",
    time: "Oct 27, 6–7 PM",
    rsvpLink: "https://forms.gle/8zHsFdFTsbRboGNK8",
  },
  {
    id: 2,
    title: "Interning and Learning",
    description:
      "Ever wonder what an internship is actually like? Come hear from UCLA students who just did it. Join a candid panel with current and recent interns across engineering industries and ask anything about the application process, day-to-day life, and how to make the most of your summer.",
    location: "Zoom",
    time: "Oct 29, 6–7 PM",
    rsvpLink: "https://forms.gle/FUdV4Xc9BqQAE3gX9",
  },
  {
    id: 3,
    title: "LockedIn with LinkedIn",
    description:
      "Your LinkedIn is your digital first impression. Join us for a live profile makeover where we transform a real LinkedIn from bland to brilliant, then stay for a social hour to meet fellow engineers and swap LinkedIns.",
    location: "Maxwell Room, Engineering IV",
    time: "Nov 3, 6–7 PM",
    rsvpLink: "https://forms.gle/shLTJoAsvwefBVT9A",
  },
  {
    id: 4,
    title: "Perfect Your Pitch",
    description:
      "Can you sell yourself in 60 seconds? Craft your elevator pitch, learn how to talk about your projects with confidence, and get real-time feedback. We'll also cover how to research companies so you walk into EWI knowing exactly what to say.",
    location: "Cohen Room, Engineering VI",
    time: "Nov 5, 6–7 PM",
    rsvpLink: "https://forms.gle/9MktfkWMmRu9AhUi7",
  },
  {
    id: 5,
    title: "Connections that Count",
    description:
      "EWI is almost here. This prep workshop covers what to wear and how to start and exit conversations with recruiters, then ends with speed networking so you can practice your pitch before the real thing.",
    location: "Cohen Room, Engineering VI",
    time: "Nov 10, 6–7 PM",
    rsvpLink: "https://forms.gle/YRbYjsJ2afs6ty149",
  },
];
